export default "__VITE_ASSET__8e82b13d__"